import React from 'react';
import PropTypes from 'prop-types';
import { indexOf } from 'lodash';
import Loading from '../Loading';
import Notice from '../../notifications/Notice';
import NotificationsWrapper from '../../notifications/NotificationsWrapper'
import ContactForm from './ContactForm';
import VerifyForm from './VerifyForm';

export default class VerifyContactInfoWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            account: props.account,
            verifiedAddress: props.verifiedAddress,
            done: props.done,
            showNotice: props.showNotice,
            noticeType: props.noticeType,
            noticeText: props.noticeText,
            updatedAccount: null
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.editProfile = this.editProfile.bind(this);
        this.saveProfile = this.saveProfile.bind(this);
    }

    componentDidMount() {
        this.props.verificationRequired();
    }

    componentWillReceiveProps(nextProps){
        let account = this.state.account;
        if (nextProps.account !== this.state.account) {
            account = nextProps.account;
        }

        let verifiedAddress = this.state.verifiedAddress;
        if (nextProps.verifiedAddress !== this.state.verifiedAddress) {
            verifiedAddress = nextProps.verifiedAddress;
        }

        let done = this.state.done;
        if (nextProps.done !== this.state.done) {
            done = nextProps.done;
        }

        let showNotice = this.state.showNotice;
        if (nextProps.showNotice !== this.state.showNotice) {
            showNotice = nextProps.showNotice;
        }

        let noticeType = this.state.noticeType;
        if (nextProps.noticeType !== this.state.noticeType) {
            noticeType = nextProps.noticeType;
        }

        let noticeText = this.state.noticeText;
        if (nextProps.noticeText !== this.state.noticeText) {
            noticeText = nextProps.noticeText;
        }

        this.setState({
            account,
            verifiedAddress,
            done,
            showNotice,
            noticeType,
            noticeText
        });
    }

    editProfile() {
        this.setState({
            verifiedAddress: null,
            updatedAccount: null,
            done: false
        });
    }

    saveProfile(){
        let accountToSave = this.state.updatedAccount;
        if ( this.state.account.home_address.country !== 'USA' ){
            accountToSave = this.state.account
        }
        this.props.saveProfile(accountToSave);
    }

    handleChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        const account = this.state.account;
        if (indexOf(['country', 'address1', 'address2', 'city', 'state', 'zip_code'], name) >= 0) {
                const address = account.home_address;
                address[name] = value;
                if (name === 'country' && value !== 'USA') {
                    address.address1 = '';
                    address.address2 = '';
                    address.city = '';
                    address.state = '';
                    address.zip_code = '';
                }
                account.home_address = address;
        }
        else {
            account[name] = value;
        }
        this.setState({
            account
        });
    }

    handleOptionChange(e) {
        const updatedAccount = {};
        Object.assign(updatedAccount, this.state.account);
        if (e.target.value === 'suggested') {
            updatedAccount.home_address = this.state.verifiedAddress;
        }
        this.setState({
            updatedAccount
        });
    }

    render() {
        if (this.state.account === null) {
            return (
                <Loading />
            );
        }
        let content = null;
        if (this.state.account) {
            content = (
                <ContactForm
                    account={this.state.account}
                    handleChange={this.handleChange}
                    saveProfile={this.saveProfile}
                    verifyAddress={this.props.verifyAddress} />
            );
        }

        if (this.state.verifiedAddress) {
            content = (
                <VerifyForm
                    verifiedAddress={this.state.verifiedAddress}
                    currentAddress={this.state.account.home_address}
                    handleOptionChange={this.handleOptionChange}
                    saveProfile={this.saveProfile}
                    editProfile={this.editProfile} />
            );
        }
        let doneMessage = "";
        if (this.state.done){
            doneMessage = (
                <div className="rec-verify-contact-done-message">
                    <NotificationsWrapper noticeType="info">
                        <p>The address has been successfully saved.</p>
                    </NotificationsWrapper>
                </div>
            )
        }
        return (
            <div className="rec-verify-contact">
                <p>
                    Customers who paid in cash will be refunded in the form of a
                    treasury check sent in the mail. Please enter the fields
                    below and verify that you have entered a USPS-recognized address.
                </p>
                <div>
                    <Notice showNotice={this.state.showNotice} noticeType={this.state.noticeType}>
                        {this.state.noticeText}
                    </Notice>
                </div>
                {content}
                {doneMessage}
            </div>
        );
    }
}

VerifyContactInfoWrapper.propTypes = {
    saveProfile: PropTypes.func,
    verifyAddress: PropTypes.func,
    verificationRequired: PropTypes.func,
    account: PropTypes.shape({
        account_id: PropTypes.string,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string
        }),
        home_phone: PropTypes.string,
        last_name: PropTypes.string
    }),
    verifiedAddress: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip_code: PropTypes.string
    }),
    done: PropTypes.bool,
    showNotice: PropTypes.bool,
    noticeType: PropTypes.string,
    noticeText: PropTypes.string
};
